import { render } from "./CreateFeed.vue?vue&type=template&id=251cadf1"
import script from "./CreateFeed.vue?vue&type=script&lang=js"
export * from "./CreateFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__